import fetch from '@/utils/fetch';
import filterNull from '@/utils/filterNull';
import { AccrualTypeList, BusinessDistrictList } from './type';

const model = {
  state: {
    unitData: [],
    unitTreeData: [],
    accrualTypeData: [],
    auditLogModalVisible: false,
    logLoading: false,
    logPageParams: {
      page: 1,
      pageSize: 5,
    },
  },
  reducers: {
    setState(state: any, partialState: any) {
      return { ...state, ...partialState };
    },
  },
  actions: ({
    dispatch: { logisticsAccrualRule },
    getState,
  }: {
    dispatch: any;
    getState: any;
  }) => ({
    // 设置审核记录弹窗展开
    setAuditLogModalVisible(flag) {
      logisticsAccrualRule.setState({ auditLogModalVisible: flag });
    },
    // 清空审核记录modal数据
    clearAuditLogModal() {
      logisticsAccrualRule.setState({
        logPageParams: { page: 1, pageSize: 5 },
        auditLogList: [],
        auditLogTotal: 0,
      });
    },
    changeLogPageParams(page, pageSize, isRule, accrualRuleId) {
      const { logPageParams } = getState().logisticsAccrualRule;
      logisticsAccrualRule.setState({ logPageParams: { ...logPageParams, page } });
      isRule
        ? logisticsAccrualRule.getRulesLog()
        : logisticsAccrualRule.getAuditLogInfo(accrualRuleId);
    },
    // 获取配送单元列表
    async getUnitList() {
      const data: any = await fetch('/saasmerchant/fsarea/distribution/unit/base/list', {
        params: {
          cbdStatus: 1, // 生效
        },
      });
      if (data?.list) {
        const unitList: any = data.list.map((unit) => ({
          key: unit.distributionUnitId,
          value: unit.distributionUnitId,
          content: unit.distributionUnitName,
        }));
        unitList.unshift({
          key: '',
          value: '',
          content: '全部',
        });
        const treeData: any = [
          {
            title: '全部',
            value: '',
            key: '',
            children: data.list.map((unit) => ({
              key: unit.distributionUnitId,
              value: unit.distributionUnitId,
              title: unit.distributionUnitName,
            })),
          },
        ];
        logisticsAccrualRule.setState({
          unitData: unitList,
          unitTreeData: treeData,
        });
      }
    },

    // 获取全部计提类型
    async getAllAccrualType(workType) {
      const data: AccrualTypeList = await fetch('/saasmerchant/fsarea/accrualtype/queryall', {
        params: { workType },
      });
      if (data) {
        logisticsAccrualRule.setState({
          accrualTypeData: data.map((type) => ({
            key: type.accrualTypeId,
            value: type.accrualTypeId,
            content: type.accrualTypeName,
          })),
        });
      }
    },
    // 获取计提规则详情
    async postAccrualRuleEffectDetail(params: any) {
      const data = await fetch('/saasmerchant/fsarea/accrualrule/detail', {
        type: 'POST',
        useJson: true,
        params,
      });
      if (data) {
        return data;
      }
      return null;
    },
    // 获取编辑计提规则详情
    async getAccrualRuleEditDetail(params: any) {
      const data = await fetch('/saasmerchant/fsarea/accrualrule/edit/detail', {
        params,
      });
      if (data) {
        return data;
      }
      return null;
    },
    // 计提规则修改/新增
    async postAccrualRuleVerify(params: any, callback: Function) {
      const data = await fetch('/saasmerchant/fsarea/accrualrule/modify', {
        type: 'POST',
        useJson: true,
        params: filterNull(params),
      });
      if (data) {
        callback();
      }
    },
    // 获取配送计提规则详情
    async postDeliveryRuleEffectDetail(params: any) {
      const data = await fetch('/saasmerchant/fsarea/accrualrule/send/detail', {
        type: 'POST',
        useJson: true,
        params,
      });
      if (data) {
        return data;
      }
      return null;
    },
    // 获取编辑配送计提规则详情
    async getDeliveryRuleEditDetail(params: any) {
      const data = await fetch('/saasmerchant/fsarea/accrualrule/edit/send/detail', {
        params,
      });
      if (data) {
        return data;
      }
      return null;
    },
    // 配送计提规则修改/新增
    async postDeliveryRuleVerify(params: any, callback: Function) {
      const data = await fetch('/saasmerchant/fsarea/accrualrule/send/modify', {
        type: 'POST',
        useJson: true,
        params: filterNull(params),
      });
      if (data) {
        callback();
      }
    },
    // 删除计提规则
    async getAccrualRuleDelete(params: any, callback: Function) {
      const data = await fetch('/saasmerchant/fsarea/accrualrule/delete', {
        params,
      });
      if (data) {
        callback();
      }
    },
    //审核通过或审核驳回按钮按下立即校验接口
    async postAuditRulePassBtnPressVerify(params: any) {
      const data = await fetch('/saasmerchant/fsarea/accrualrule/examine/check', {
        type: 'POST',
        useJson: true,
        params,
      });
      if (data) {
        return data;
      }
      return null;
    },
    //审核计提规则
    async postAuditRulePassVerify(params: any) {
      const data = await fetch('/saasmerchant/fsarea/accrualrule/examine', {
        type: 'POST',
        useJson: true,
        params,
      });
      if (data) {
        return data;
      }
      return null;
    },
    // 审核记录弹窗展示信息获取
    async getAuditLogInfo(accrualRuleId) {
      const { logPageParams } = getState().logisticsAccrualRule;
      logisticsAccrualRule.setState({ logLoading: true });
      const data = await fetch('/saasmerchant/fsarea/accrualrule/examine/detail', {
        params: {
          accrualRuleId,
          ...logPageParams,
        },
      });
      logisticsAccrualRule.setState({ logLoading: false });
      if (data) {
        logisticsAccrualRule.setState({
          auditLogList: data.list,
          auditLogTotal: data.total,
        });
      }
    },
  }),
};

export default model;
